import React from 'react';
import { Box, Button, Modal, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import moment from 'moment';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  minHeight: 145,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function SchoolSessionModal({ academicSessions, showAddModel, open, onClose }) {
  const sessionColumns = [
    {
      Header: 'Name',
      Cell: (val) => {
        const name = val.cell.row.original.name;
        return <p>{name}</p>;
      },
    },

    {
      Header: 'Start Date',
      Cell: (val) => {
        const { startDate } = val.cell.row.original;
        if (startDate) return moment(startDate).format('DD MMM YYYY');
        return '';
      },
    },
    {
      Header: 'End Date',
      Cell: (val) => {
        const { endDate } = val.cell.row.original;

        if (endDate) return moment(endDate).format('DD MMM YYYY');
        return '';
      },
    },
    {
      Header: 'IsActive',
      Cell: (val) => {
        const isActive = val.cell.row.original.isActive;
        return <p>{isActive ? 'True' : 'False'}</p>;
      },
    },
  ];

  return (
    <Modal open={open} onClose={onClose}>
      <>
        <CloseIcon />
        <Box sx={style}>
          <Typography variant="h5">
            <Box fontWeight={'fontWeightMedium'}>Academic Session Details</Box>
          </Typography>
          {/* <Box /> */}

          <Box my={1} style={{ display: 'flex', alignItems: 'center' }} />

          <Box my={2}>
            <BuzzTable columns={sessionColumns} data={academicSessions} />
          </Box>
        </Box>
      </>
    </Modal>
  );
}

export default SchoolSessionModal;
